import { Banner } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";

export const RequiredFieldsMissingBanner = () => {
  const { submitCount, isValid } = useFormContext();

  const showBanner = submitCount > 0 && !isValid;

  if (!showBanner) return null;

  return (
    <Banner
      variant="danger"
      title="Required information is missing"
      description="Please review and complete the required fields highlighted."
    />
  );
};
